module.exports = __webpack_public_path__ + "img/86.2.TN.0487deba.png";